import GymRatingReportRepository from '@/shared/http/repositories/socialProject/gymRating-report'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading } from '@/shared/utils/UIHelper'
import VueHighcharts from 'vue2-highcharts'

export default {
  components: {
      VueHighcharts
  },

  props: {
    studentId: {
      type: String,
      default: null
    }
  },

  data: () => ({
    options: {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Rendimento do Aluno'
      },
      subtitle: {
        text: 'Média de Supino'
      },
      xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            style: {
                color: '#0d75a3',
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
            }
        }
      },
      yAxis: {
        min: 0,
        title: {
            text: 'Médias'
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: 'Média dê: <b>{point.y:.1f} Supino</b>'
      },
      series: [{
        name: 'Médias',
        dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#FFFFFF',
            align: 'right',
            format: '{point.y:.1f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif',
            }
        }
      }]
    }
  }),

  watch: {
    studentId: {
      handler: function (value) {
        if (value) {
          this.loadChargeData(value)
        }
      },
      immediate: true
    }
  },

  methods: {
    loadChargeData(id) {
      loading.push()
      GymRatingReportRepository.GetAllAvgStudentByStudentId(id)
      .then(response => {

        if(!IsSuccessCode){
          loading.pop()
          return Promise.reject()
        }

        const student = response.data.data

        let seasonName = []
        let studentBrenchPressAverage = []
        
        if (student.studentAvgsBrenchPress.length != 0) {
          seasonName = student.seasonName
          studentBrenchPressAverage = student.studentAvgsBrenchPress.filter(c => c != null)
        }

        setTimeout(() => {
          this.$refs.lineCharts.chart.update({
            xAxis: {
              categories: seasonName,
              text: null
            },
            series: [{
              name: 'Média',
              data: studentBrenchPressAverage
            }],
            title: {
              text: 'Rendimento do Aluno',
              align: 'center'
            },
            subtitle: {
              text: 'Média de Supino',
              align: 'center'
            }
          })

          loading.pop()
        }, 1300)
      })
      .catch(e => {
        loading.pop()
        console.log(`Erro ao tentar obter os dados para o gráfico de rendimentos do aluno: \n ${e}`)
      })
    }
  }
}